<template>
  <div ref="list" class="message-list" @scroll="onScroll">
    <template v-for="(item, index) in messages">
      <message
        v-if="item.type == 'msg'"
        :key="index"
        ref="message"
        :value="item"
        @typingFinish="item.needTyping = false"
      ></message>
      <message-hint
        v-if="item.type == 'hint' && item.show"
        :key="index"
        :value="item"
      ></message-hint>
    </template>
  </div>
</template>

<script>
import adaptation from '@/mixins/adaptation'
import message from './message.vue'
import messageHint from './messageHint.vue'
import avatarImg from '@/assets/images/avatar.png'
import robotImg from '@/assets/images/chatrobot/robot-avatar.png'
export default {
  name: 'MessageList',
  components: {
    messageHint: messageHint,
    message: message
  },
  mixins: [adaptation],
  adaptationVarsDefine: {
    halfLineHeight: 24
  },
  data() {
    let _hasMore = false
    let _pageSize = 10
    let _lastConversationId = ''
    let _isLoading = false
    let _loadTriggerOffset = 36
    let _lastScrollTop = NaN
    let _loadingDelay = 500
    let _timeoutIns = null
    let _manualScrollTimeoutIns = null
    let _manualScrollDelay = 2000
    let _manualScroll = false
    let _listScrollTop = NaN
    let isLoading = () => {
      return _isLoading
    }
    let loading = () => {
      if (_timeoutIns) {
        clearTimeout(_timeoutIns)
        _timeoutIns = null
      }
      _isLoading = true
    }
    let finishLoading = () => {
      _isLoading = false
    }
    let getConfig = () => {
      return {
        pageSize: _pageSize,
        lastConversationId: _lastConversationId
      }
    }
    let hasMore = () => {
      return _hasMore
    }
    let setConfig = (hasMore, lastConversationId) => {
      _hasMore = hasMore
      _lastConversationId = lastConversationId
    }
    let isScrollUp = function(scrollTop) {
      let r = false
      if (!isNaN(_lastScrollTop) && !isNaN(scrollTop)) {
        r = scrollTop - _lastScrollTop < 0 && scrollTop < _loadTriggerOffset
      }
      _lastScrollTop = scrollTop
      return r
    }
    let delayFinishLoading = function() {
      if (_timeoutIns) {
        clearTimeout(_timeoutIns)
        _timeoutIns = null
      }
      _timeoutIns = setTimeout(() => {
        finishLoading()
      }, _loadingDelay)
    }
    let storeListHeight = function(height) {
      _listScrollTop = height
    }
    let calListScrollTop = function(height) {
      return height - _listScrollTop
    }
    let manualScrollDelay = function() {
      if (_manualScrollTimeoutIns) {
        clearTimeout(_manualScrollTimeoutIns)
        _manualScrollTimeoutIns = null
      }
      _manualScroll = true
      _manualScrollTimeoutIns = setTimeout(() => {
        _manualScroll = false
      }, _manualScrollDelay)
    }
    let isManualScroll = function() {
      return _manualScroll
    }

    return {
      messages: [],
      loadMore: {
        //下拉加载更多逻辑集合
        isLoading: isLoading,
        loading: loading,
        finishLoading: finishLoading,
        getConfig: getConfig,
        setConfig: setConfig,
        hasMore: hasMore,
        isScrollUp: isScrollUp,
        delayFinishLoading: delayFinishLoading,
        storeListHeight: storeListHeight,
        calListScrollTop: calListScrollTop,
        manualScrollDelay: manualScrollDelay,
        isManualScroll: isManualScroll
      },
      intervalIns: null,
      adaptationVars: {
        halfLineHeight: 24
      }
    }
  },
  methods: {
    buildAQues(info) {
      return {
        type: 'msg',
        role: 'user',
        avatarImg: avatarImg,
        text: info
      }
    },
    buildAResponce(info, id, isThinking, needTyping) {
      return {
        type: 'msg',
        role: 'assistant',
        avatarText: 'AI',
        avatarImg: robotImg,
        text: info,
        id: id,
        isThinking: isThinking,
        needTyping: needTyping
      }
    },
    buildATimeHint(time, id) {
      return {
        type: 'hint',
        text: time,
        time: new Date(time).getTime(),
        isTime: true,
        id: id
      }
    },
    buildANormalHint(hint, id) {
      return {
        type: 'hint',
        text: hint,
        id: id,
        show: true
      }
    },
    appendAQues(info, time) {
      let hint = this.buildATimeHint(time)
      this.messages.push(hint)

      let ques = this.buildAQues(info)
      this.messages.push(ques)
    },
    unShiftAQues(info, time) {
      let ques = this.buildAQues(info)
      this.messages.unshift(ques)

      let hint = this.buildATimeHint(time)
      this.messages.unshift(hint)
    },
    appendAResponce(info, time, needTyping) {
      let hint = this.buildATimeHint(time)
      this.messages.push(hint)

      let res = this.buildAResponce(info, null, false, needTyping)
      this.messages.push(res)
    },
    unshiftAResponce(info, time) {
      let res = this.buildAResponce(info)
      this.messages.unshift(res)

      let hint = this.buildATimeHint(time)
      this.messages.unshift(hint)
    },
    clearByID(id) {
      this.messages = this.messages.filter(e => e.id != id)
    },
    clearTempResponce() {
      let id = 'temp'
      this.clearByID(id)
    },
    updateATempResponce(info, time, isThinking, needTyping) {
      let id = 'temp'
      this.clearByID(id)

      let hint = this.buildATimeHint(time, id)
      this.messages.push(hint)

      let res = this.buildAResponce(info, id, isThinking, needTyping)
      this.messages.push(res)
    },
    addASelfIntroduction() {
      let res = this.buildAResponce('您好，我是您的智能助理，有什么问题不妨问问我吧~')
      this.messages.push(res)
    },
    addAHistoryHint() {
      let hint = this.buildANormalHint('--以上为历史消息--')
      this.messages.push(hint)
    },
    addANoMoreHint(hasMore) {
      let id = 'has-more-hint'
      this.clearByID(id)

      let hint = this.buildANormalHint(`--${hasMore ? '向上以加载更多' : '没有更多消息了'}--`, id)
      this.messages.unshift(hint)
    },
    getMessageList(isInit = true, pageSize = 30, lastConversationId = '') {
      if (isInit) {
        this.messages = []
      }
      let self = this

      let params = {
        uid: String(JSON.parse(localStorage.getItem('cbaas_system_userInfo')).ID),
        page_size: pageSize,
        last_conversation_id: lastConversationId
      }

      this.loadMore.storeListHeight(this.$refs.list.scrollHeight)
      this.$apis.chatrobot
        .getMessageList(params)
        .then(result => {
          if (result && result.code == 200 && result.object) {
            let object = result.object
            for (let i = 0; i < object.list.length; i++) {
              let item = object.list[i]

              if (item.role == 'user') {
                self.unShiftAQues(item.content, item.create_time)
              } else if (item.role == 'assistant') {
                self.unshiftAResponce(item.content, item.create_time)
              }
            }
            self.loadMore.setConfig(object.has_more, object.last_conversation_id)
            self.loadMore.delayFinishLoading()

            //添加显示更多提示
            self.addANoMoreHint(object.has_more)

            if (isInit) {
              object.list.length > 0 && self.addAHistoryHint()
              self.addASelfIntroduction()

              self.handleMessages()
              self.scrollToEnd()
            } else {
              self.handleMessages()
              self.scrollToStoreInstant()
            }
          } else {
            self.$message.warning('获取消息列表失败，请检查您的网络！')
            if (isInit) {
              self.addASelfIntroduction()
              self.handleMessages()
              self.scrollToEnd()
            }
          }
        })
        .catch(err => {
          console.log(err)
          self.$message.warning('获取消息列表失败，请检查您的网络！')
          self.loadMore.delayFinishLoading()
          if (isInit) {
            self.addASelfIntroduction()
            self.handleMessages()
            self.scrollToEnd()
          }
        })
    },
    scrollToEnd() {
      let self = this
      this.$nextTick(() => {
        let scrollTop = self.$refs.list.scrollHeight - self.$refs.list.clientHeight
        self.$refs.list.scrollTo({
          top: scrollTop,
          left: 0,
          behavior: 'smooth'
        })
      })
    },
    scrollToStoreInstant() {
      let self = this
      this.$nextTick(() => {
        let top = self.loadMore.calListScrollTop(self.$refs.list.scrollHeight)
        self.$refs.list.scrollTo({
          top: top,
          left: 0,
          behavior: 'instant'
        })
      })
    },
    onScroll(event) {
      let scrollTop = event.target.scrollTop
      this.loadMore.manualScrollDelay()
      if (this.loadMore.isScrollUp(scrollTop) && !this.loadMore.isLoading()) {
        this.loadMore.loading()
        if (this.loadMore.hasMore()) {
          let config = this.loadMore.getConfig()
          this.getMessageList(false, config.pageSize, config.lastConversationId)
        } else {
          this.$message.info('没有更多消息了!')
          this.loadMore.delayFinishLoading()
        }
      }
    },
    init() {
      this.getMessageList()
      this.intervalIns && clearInterval(this.intervalIns)
      let self = this
      this.intervalIns = setInterval(() => {
        self.$refs.message
          ?.filter(e => e.needUpdate())
          .forEach(e => {
            e.onUpdate()

            if (!self.loadMore.isManualScroll() || self.isAtTheListBottom()) {
              self.scrollToEnd()
            }
          })
      }, 100)
    },
    close() {
      this.intervalIns && clearInterval(this.intervalIns)
      this.intervalIns = null
    },
    handleMessages() {
      let timeHints = []
      //间隔两分钟之内，则合并时间提示
      let interval = 2 * 60 * 1000
      for (let i = 0; i < this.messages.length; i++) {
        let item = this.messages[this.messages.length - (i + 1)]

        if (item.type == 'hint' && item.isTime) {
          timeHints.push(item)

          if (timeHints.length > 3) {
            timeHints.shift()
          }
        }

        if (timeHints.length == 3) {
          let interval01 = timeHints[0].time - timeHints[1].time
          let interval12 = timeHints[1].time - timeHints[2].time
          if (interval01 < interval) {
            timeHints[1].show = true
            timeHints[0].show = false
          } else {
            timeHints[1].show = true
            timeHints[0].show = true
          }

          if (interval12 < interval) {
            timeHints[2].show = true
            timeHints[1].show = false
          } else {
            timeHints[2].show = true
            timeHints[1].show = true
          }
        } else if (timeHints.length == 2) {
          let interval01 = timeHints[0].time - timeHints[1].time
          if (interval01 < interval) {
            timeHints[1].show = true
            timeHints[0].show = false
          } else {
            timeHints[1].show = true
            timeHints[0].show = true
          }
        } else if (timeHints.length == 1) {
          timeHints[0].show = true
        }
      }
    },
    clearMessages() {
      this.getMessageList()
    },
    isAtTheListBottom() {
      let list = this.$refs.list
      let halfLineHeight = this.adaptationVars.halfLineHeight
      //如果在列表在底部半行内的距离，则认为在底部
      return list.scrollTop + halfLineHeight >= list.scrollHeight - list.clientHeight
    }
  }
}
</script>

<style lang="scss" scoped>
.message-list {
  display: flex;
  flex-direction: column;
}
</style>
